// extracted by mini-css-extract-plugin
export default {"root":"EditMachineModal_root__9g7+R","buttonDelete":"EditMachineModal_buttonDelete__voqh6","placeHolderShimmer":"EditMachineModal_placeHolderShimmer__tCqnr"};